import { Controller } from "@hotwired/stimulus"
import { enter, leave } from "el-transition"

// Connects to data-controller="dropdown-vertrag"
export default class extends Controller {
	static values = {
		open: false,
		contentBreite: Number,
	}
	static targets = ["button", "content"]

	connect() {
		// Content positionieren
		this.contentBreiteValue = this.contentTarget.offsetWidth
		this.contentTarget.classList.add("hidden")

		// Transition Classes zum Content Target hinzufügen
		this.contentTarget.setAttribute("data-transition-enter", "transition ease-out duration-100")
		this.contentTarget.setAttribute("data-transition-enter-start", "transform opacity-0 scale-95")
		this.contentTarget.setAttribute("data-transition-enter-end", "transform opacity-100 scale-100")
		this.contentTarget.setAttribute("data-transition-leave", "transition ease-in duration-75")
		this.contentTarget.setAttribute("data-transition-leave-start", "transform opacity-100 scale-100")
		this.contentTarget.setAttribute("data-transition-leave-end", "transform opacity-0 scale-95")

		// Im Button die Toogle Action hinzufügen
		this.buttonTarget.dataset.action = "click->dropdown-vertrag#toggle"
	}

	toggle() {
		// console.log("dropdown#toggle")
		if (this.openValue) {
			this.close()
		} else {
			this.open()
		}
	}

	closeByClick(event) {
		if (!this.content) return

		// Wenn das Dropdown nicht offen ist braucht es nicht geschlossen werden
		if (!this.openValue) return

		// Click auf den Button ignorieren
		if (this.buttonTarget.contains(event.target)) return

		// Click innerhalb des Contents des Dropdowns ignorieren
		if (this.content.contains(event.target)) return

		this.close()
	}

	open() {
		// Wenn es schon offen ist braucht es nicht noch einmal geöffnet werden
		if (this.openValue) return

		this.openValue = true
		this.buttonTarget.dataset.ui = "aktiv"

		const copy = this.contentTarget.cloneNode(true)
		document.querySelector("body").appendChild(copy)
		this._closeOnLinkClick = (event) => {
			const link = event.target.closest("a")
			if (!link) return
			this.close()
		}
		copy.addEventListener("click", this._closeOnLinkClick, true)
		enter(copy)
		copy.style.top = this.buttonTarget.getBoundingClientRect().top + this.buttonTarget.offsetHeight / 2.0 + "px"
		copy.style.left =
			this.buttonTarget.getBoundingClientRect().left -
			copy.offsetWidth -
			this.buttonTarget.offsetWidth * 0.25 +
			"px"
		copy.style.width = "fit-content"

		this.content = copy
	}

	close() {
		this.openValue = false
		if (this.content && this._closeOnLinkClick) {
			this.content.removeEventListener("click", this._closeOnLinkClick, true)
			this._closeOnLinkClick = null
		}
		leave(this.content).then(() => {
			this.content.remove()
		})
		this.buttonTarget.removeAttribute("data-ui")
	}
}
